<template>
  <div>
    <v-menu
      v-model="popup"
      @click.native.stop.prevent
      :close-on-content-click="false"
      offset-y
      left
      bottom
      absolute
      content-class="hyp-label-menu"
    >
      <template v-slot:activator="{ on }">
        <v-icon
          v-on="on"
          title="Label article"
          size="11"
          class="hyp-label-icon"
          :color="iconColor"
          @click.native.stop.prevent
          >fas fa-tag</v-icon
        >
      </template>
      <div>
        <v-list>
          <v-list-item
            v-for="(color, $index) in colorList"
            :key="$index"
            @click="handleClick(color)"
          >
            <v-list-item-action>
              <v-icon class="ml-2" :color="color.value">fas fa-tag</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="color.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-menu>
  </div>
</template>

<script>
import lodashFind from "lodash/find";
import lodashCloneDeep from "lodash/cloneDeep";

import { LABEL_COLORS } from "@/common/constants/collaboration";

const EMITTED_ACTIONS = {
  CLICK: "click",
};

export default {
  name: "ColoredLabelPicker",
  props: {
    color: {
      type: String,
    },
    colors: {
      type: Array,
    },
  },
  data() {
    let colors = lodashCloneDeep(LABEL_COLORS);
    if (this.colors) {
      colors = this.colors;
    }
    const COLOR = lodashFind(LABEL_COLORS, ["value", this.color]);
    return {
      popup: false,
      selectedColor: COLOR,
      colorList: colors,
    };
  },
  computed: {
    iconColor() {
      if (this.selectedColor && this.selectedColor.value) {
        return this.selectedColor.value;
      }
      return "#000000";
    },
  },
  methods: {
    handleClick(color) {
      this.selectedColor = color;
      this.popup = false;
      this.$emit(EMITTED_ACTIONS.CLICK, color.value);
    },
  },
  watch: {
    colors: {
      handler() {
        if (this.colors) {
          this.colorList = this.colors;
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.selectedColor = null;
  },
};
</script>

<style scoped>
.hyp-label-icon {
  cursor: pointer;
}
</style>
